import { LE_AGENT_HUB, LUXURY_ESCAPES } from '~/consts/brands';
import {
  DESTINATION_SEGMENT_ID,
  FORM_TYPE_CUSTOM,
  FORM_TYPE_DEFAULT,
  HOLIDAY_TYPE_SEGMENT_ID,
} from '~/consts/customerCommunication/heroPlanner';

export function isScheduleIsCustomScheduleType(
  schedule: CustomerCommunication.UnsavedHeroPlannerSchedule | CustomerCommunication.UnsavedCustomSchedule | undefined,
): schedule is CustomerCommunication.UnsavedCustomSchedule {
  if (!schedule || !('type' in schedule)) {
    return false;
  }
  // agent hub will always be a custom schedule
  const isLeAgentHubBrand = schedule.brandId === LE_AGENT_HUB;
  // destination and holiday type are also custom schedules
  const isCustomSegment =
    schedule.segmentId === DESTINATION_SEGMENT_ID || schedule.segmentId === HOLIDAY_TYPE_SEGMENT_ID;
  return isLeAgentHubBrand || isCustomSegment;
}

export function isCustomSchedule(segment?: string, brand?: string): boolean {
  if (segment === DESTINATION_SEGMENT_ID || segment === HOLIDAY_TYPE_SEGMENT_ID || brand === LE_AGENT_HUB) {
    return true;
  }
  return false;
}

export function getHeroPlannerFormType(segment?: string, brand?: string): string {
  if (segment === DESTINATION_SEGMENT_ID || segment === HOLIDAY_TYPE_SEGMENT_ID || brand === LE_AGENT_HUB) {
    return FORM_TYPE_CUSTOM;
  }
  return FORM_TYPE_DEFAULT;
}

export function isDestinationContentOptional(segment?: string, brand?: string): boolean {
  return brand === LUXURY_ESCAPES && (segment === DESTINATION_SEGMENT_ID || segment === HOLIDAY_TYPE_SEGMENT_ID);
}
